import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesAutoSafe,
    useStylesAutoBlack,
} from '../../../St/Reports/UseStyle';
//=====================================================================
import { useTranslation } from "react-i18next";
import { SaleCheckbox, useStylesContainers } from '../../../St/comps/UseStyle';
import { Button, ButtonBase, colors, Container, Divider, FormControlLabel, Hidden } from '@material-ui/core';
import ReceiptVoucherType from '../../Accounts/BackEnd/receipt-voucher/components/ReceiptVoucher-typeFilter';
import SalaryFilter from './SalaryFilter';
import { sto } from '../../../Context/InshData';
import { GetItemFromOptions } from '../../../services/global-services';
import RestInfoDialog from '../../Invs/BackEnd/models/RestInfo/RestInfoDialog';

export default function EmployeesSalaryForm(props) {

    const {
        AutoOptions,
        params,
        valueAutos,
        years,
        months,
        onChange,
        onChangeAuto,
        setParams,
        setValueAutos,
        addProfSalary,
        setAddProfSalary,
        branch,
        costCenters,
        onChangeSalary,
        advances,
        prevent

    } = props;

    const clasASafe = useStylesAutoSafe();

    const clsConts = useStylesContainers();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const clasBalck = useStylesAutoBlack();

    const { t } = useTranslation(["forms", "translation"]);
    let total_salary = (Number(params?.tot_salary) + Number(params?.salary_add)) -
        (Number(params?.salary_sub) + Number(params?.tot_advances));

    const onOpenProf = (e) => {
        setAddProfSalary(e.target.checked);
        setParams({ ...params, salary_prof: params.salary_net });
    };
    const valuebranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches ?? []);
    const [infoData, setInfoData] = useState({ open: false });

    return (
        <React.Fragment>
            <Grid item container xs={12} className={[clsConts.rootup]}>
                <Grid
                    item
                    container
                    spacing={1}
                    lg={12} md={12} sm={12} xs={12}
                >

                    <Grid item lg={3} md={3} sm={4} xs={12} style={{ marginTop: "0.7rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameA"
                            label={t("no")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                            type="number"
                            name="id"
                            value={params.no}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} sm={4} xs={12} style={{ marginTop: "0.7rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            // value={valueAutos.branch}
                            value={branch.id == -1 ? valuebranch : branch}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                onChangeAuto("branch", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Branches}
                            disabled={!prevent ? true : sto.User_typei == 1 ? false : true}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:branch")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={3} md={3} sm={4} xs={12} style={{ marginTop: "0.7rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.emp}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                onChangeAuto("emp", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Employees}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{ background: colors.blueGrey[50] }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:employee")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>


                    <Grid item lg={3} md={3} sm={4} xs={12} style={{ marginTop: "0.7rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.emp_resp}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                onChangeAuto("emp_resp", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Employees}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={"الموظف المسؤول"}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>


                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.7rem" }}>
                        <TextField
                            fullWidth
                            className={clasTF.rootCust}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            variant="outlined"
                            size="small"
                            id="date"
                            label={t("date")}
                            type="date"
                            format="YYYY-MM-DD"
                            name="datef"
                            value={params.date}
                            onChange={onChange("date")}
                        />
                    </Grid>


                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.7rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.center}
                            onChange={(event, newValue) => {
                                onChangeAuto("center", newValue);
                            }}
                            id="combo-box-demo"
                            size="small"
                            options={costCenters}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                    label={t("center")}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.7rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.month}
                            onChange={(event, newValue) => {
                                onChangeAuto("month", newValue);
                            }}
                            id="combo-box-demo"
                            size="small"
                            options={months}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                    label={"الشهر"}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.7rem" }}>
                        <Autocomplete
                            classes={clasBalck}
                            value={valueAutos.year}
                            onChange={(event, newValue) => {
                                onChangeAuto("year", newValue);
                            }}
                            id="combo-box-demo"
                            size="small"
                            options={years}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                    label={"السنة "}
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginTop: "1rem" }}>
                        <Divider style={{ background: '#4a82b9', height: 1.5 }} />
                        <Divider
                            style={{ background: '#4a82b9', marginTop: 3, height: 1.5 }}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginTop: "0.7rem" }}>
                        <SalaryFilter
                            {...{
                                params,
                                setParams,
                                onChange,
                                AutoOptions,
                                valueAutos,
                                setValueAutos
                            }}
                        />
                    </Grid>
                    {params.type == "1" ?
                        (
                            <Grid item lg={3} md={3} sm={4} xs={12} style={{ marginTop: "0.7rem" }}>
                                <Autocomplete
                                    classes={clasBalck}
                                    value={valueAutos.safe_bank_id}
                                    onChange={(event, newValue) => {
                                        onChangeAuto("safe_bank_id", newValue);
                                    }}
                                    id="combo-box-demo"
                                    size="small"
                                    options={AutoOptions.Stocks}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    style={{ backgroundColor: colors.blueGrey[50] }}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                            label={t("stock")}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                        )
                        :
                        (
                            <Grid item lg={3} md={3} sm={4} xs={12} style={{ marginTop: "0.7rem" }}>
                                <Autocomplete
                                    classes={clasBalck}
                                    value={valueAutos.safe_bank_id}
                                    onChange={(event, newValue) => {
                                        onChangeAuto("safe_bank_id", newValue);
                                    }}
                                    id="combo-box-demo"
                                    size="small"
                                    options={AutoOptions.Banks}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    style={{ backgroundColor: colors.blueGrey[50] }}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                                            label={t("account")}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                        )
                    }




                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.7rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Address"
                            label="اجمالي الراتب"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="number"
                            name="salary"
                            value={params?.tot_salary}
                            onChange={onChangeSalary("tot_salary")}
                        />
                    </Grid>


                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.7rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Address"
                            label="حوافز وبدلات"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="number"
                            name="hafs"
                            value={params?.salary_add}
                            onChange={onChangeSalary("salary_add")}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} sm={4} xs={6} style={{ marginTop: "0.7rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Address"
                            label="خصومات"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="number"
                            name="salary_sub"
                            value={params?.salary_sub}
                            onChange={onChangeSalary("salary_sub")}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} sm={4} xs={12} style={{ marginTop: "0.7rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Address"
                            label="اجمالي السلف السابقة"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            style={{ backgroundColor: colors.red[50] }}
                            InputProps={{ className: claslbl.clrBlackLblS, readOnly: true }}
                            type="number"
                            name="salary_net"
                            value={params?.tot_advances}
                        />
                    </Grid>

                    <Grid item lg={3} md={3} sm={4} xs={12} style={{ marginTop: "0.7rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Address"
                            label="الصافي"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            style={{ backgroundColor: colors.blueGrey[50] }}
                            InputProps={{ className: claslbl.clrBlackLblS, readOnly: true }}
                            type="number"
                            name="salary_net"
                            value={total_salary}
                        />
                    </Grid>

                    <Grid item lg={!prevent ? 11 : 12} md={!prevent ? 11 : 12} sm={!prevent ? 11 : 12} xs={12} style={{ marginTop: "0.7rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="notes"
                            label="ملاحضات"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="text"
                            name="notes"
                            multiline
                            value={params.notes}
                            onChange={onChange("notes")}
                        />
                    </Grid>
                    {!prevent &&
                        (
                            <Grid item lg={1} md={1} sm={1} xs={1} style={{ marginTop: "1rem" }}>
                                <Hidden only={["xs"]}>
                                    <Button
                                        fullWidth
                                        autoFocus
                                        variant="contained"
                                        color="#000"
                                        onClick={(e) => {
                                            setInfoData({ open: true, })
                                        }}
                                        style={{
                                            background: colors.grey[300],
                                            ...{
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                            },
                                        }}
                                    >
                                        {"القيد" + "  "}
                                    </Button>
                                </Hidden>
                            </Grid>
                        )}

                    {!prevent && (
                        <RestInfoDialog
                            infoData={infoData}
                            setInfoData={setInfoData}
                            res_id={params.rest_id}
                            branch={params.branch}
                            fromInv={0}
                            proc_id={0}
                        />
                    )}
                    <Grid item lg={5} md={5} sm={5} xs={12} style={{ marginTop: "0.7rem" }}>
                        <FormControlLabel
                            id="showPaid"
                            value="addProfSalary"
                            name="showPaid"
                            className={claslbl.clor}
                            control={
                                <SaleCheckbox
                                    checked={addProfSalary}
                                    onChange={(e) => {
                                        // setAddProfSalary(e.target.checked);
                                        onOpenProf(e);
                                    }}
                                    color={"#f18584"}
                                />
                            }
                            label=" قـيد اثبات راتب"
                            labelPlacement="end"
                        />
                    </Grid>
                    <Grid item lg={5} md={5} sm={5} xs={12} style={{ marginTop: "1.2rem" }}>

                    </Grid>


                </Grid>
            </Grid>

        </React.Fragment>
    );

}